import { AfterViewInit, Component, Input, OnChanges, OnInit, SimpleChanges, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { CarRefActions } from 'src/app/common/store/actions/carref.actions';
import { Store } from '@ngrx/store';
import { CarFeature } from 'src/app/public/car/models/car-feature.model';
import { AppFunctions } from 'src/app/public/common/constants/app-functions';

@Component({
    selector: 'app-carref-features',
    templateUrl: './carref-features.component.html',
    styleUrl: './carref-features.component.css',
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CarrefFeaturesComponent implements OnInit, OnChanges, AfterViewInit {

  @Input() features: CarFeature[] = [];

  newItem: CarFeature = new CarFeature('', '');
  editedItem: CarFeature = new CarFeature('', '');

  displayedColumns: string[] = ['id', 'code','name', 'lastUpdated', 'actions'];
  dataSource = new MatTableDataSource<CarFeature>(this.features);

  @ViewChild(MatPaginator) paginator! : MatPaginator;
  @ViewChild(MatSort) sort! : MatSort;

  editingItemId: number = 0;
  editingItem: boolean = false;

  constructor(
    private store: Store){
  
  }

  ngOnInit(){
    this.store.dispatch (CarRefActions.featuresFetchSubmit({}));
  }

  ngAfterViewInit(): void {
    this.dataSource.paginator = this.paginator;
    this.dataSource.sort = this.sort;
  }

  ngOnChanges(changes: SimpleChanges){
    if(changes['features']){
      this.dataSource.data = changes['features'].currentValue;
      
    }
  }

  applyFilter(event: Event){
    const filterValue = (event.target as HTMLInputElement).value;
    this.dataSource.filter = filterValue.trim().toLowerCase();

    if(this.dataSource.paginator){
      this.dataSource.paginator.firstPage();
    }
  }
  
  addNewRow(){
    //const newManuf = new CarFeature('','',false);
    if(! (this.editingItem  && this.editingItemId === 0)){
      this.editedItem = new CarFeature('','');
      this.dataSource.data = [...this.dataSource.data, new CarFeature('','')];
      this.editingItemId = 0;
      this.editingItem = true;
    }
    
  }

  editItem(id: number){
    this.editingItemId = id;
    this.editingItem = true;
    //console.log(this.features.find((manuf: CarFeature) => manuf.id === id));
    this.editedItem = Object.assign({}, this.editedItem, this.features.find((item: CarFeature) => item.id === id) );
    //console.log(this.editedItem);
  }

  SaveItem(id: number){
    this.editingItemId = 0;
    this.editingItem = false;
    //console.log(this.editedItem);
    //console.log(this.features.find((manuf: CarFeature) => manuf.id === id));
    this.editedItem = Object.assign({}, this.features.find((manuf: CarFeature) => manuf.id === id), this.editedItem);
    
    console.log(this.editedItem);
  
    if(id===0){
      this.store.dispatch (CarRefActions.featureNewSubmit({feature: this.editedItem }));
    } else{
      this.editedItem.id=id;
      console.log(this.editedItem);
      this.store.dispatch (CarRefActions.featureUpdateSubmit({feature: this.editedItem }));
    }
    
  }

  deleteItem(id: number){
    console.log(id)
    if(id ===0 || this.editingItem){
      this.dataSource.data = this.dataSource.data.filter(manuf => manuf.id !== 0);
      this.editingItem = false;
      this.editingItemId === 0
    }
      else{
        this.store.dispatch (CarRefActions.featureDeleteSubmit({featureId: id }));
    }
    
  }

  editedItemIsValid(): boolean{
    return this.editedItem.name.length > 0;
   }

  dateTimeFormat(dt: string): string{

    return AppFunctions.stringToDatetime(dt);
  }

}
